'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var ipns = require('ipns');

var _require = require('multihashes'),
    fromB58String = _require.fromB58String,
    toB58String = _require.toB58String;

var PubsubDatastore = require('datastore-pubsub');

var withIs = require('class-is');

var errcode = require('err-code');

var debug = require('debug');

var log = debug('ipfs:ipns:pubsub');
log.error = debug('ipfs:ipns:pubsub:error'); // Pubsub datastore aims to manage the pubsub subscriptions for IPNS

var IpnsPubsubDatastore = /*#__PURE__*/function () {
  function IpnsPubsubDatastore(pubsub, localDatastore, peerId) {
    _classCallCheck(this, IpnsPubsubDatastore);

    this._pubsub = pubsub;
    this._subscriptions = {}; // Bind _handleSubscriptionKey function, which is called by PubsubDatastore.

    this._handleSubscriptionKey = this._handleSubscriptionKey.bind(this);
    this._pubsubDs = new PubsubDatastore(pubsub, localDatastore, peerId, ipns.validator, this._handleSubscriptionKey);
  }
  /**
   * Put a value to the pubsub datastore indexed by the received key properly encoded.
   * @param {Buffer} key identifier of the value.
   * @param {Buffer} value value to be stored.
   * @param {function(Error)} callback
   * @returns {void}
   */


  _createClass(IpnsPubsubDatastore, [{
    key: "put",
    value: function () {
      var _put = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, value) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this._pubsubDs.put(key, value));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function put(_x, _x2) {
        return _put.apply(this, arguments);
      }

      return put;
    }()
    /**
     * Get a value from the pubsub datastore indexed by the received key properly encoded.
     * Also, the identifier topic is subscribed to and the pubsub datastore records will be
     * updated once new publishes occur.
     * @param {Buffer} key identifier of the value to be obtained.
     * @param {function(Error, Buffer)} callback
     * @returns {void}
     */

  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(key) {
        var res, err, ns, stringifiedTopic, id;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this._pubsubDs.get(key);

              case 3:
                res = _context2.sent;
                _context2.next = 9;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](0);
                err = _context2.t0;

              case 9:
                // Add topic subscribed
                ns = key.slice(0, ipns.namespaceLength);

                if (ns.toString() === ipns.namespace) {
                  stringifiedTopic = toB58String(key);
                  id = toB58String(key.slice(ipns.namespaceLength));
                  this._subscriptions[stringifiedTopic] = id;
                  log("subscribed to pubsub topic ".concat(stringifiedTopic, ", id ").concat(id));
                } // If no data was obtained, after storing the subscription, return the error.


                if (!err) {
                  _context2.next = 13;
                  break;
                }

                throw err;

              case 13:
                return _context2.abrupt("return", res);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 6]]);
      }));

      function get(_x3) {
        return _get.apply(this, arguments);
      }

      return get;
    }() // Modify subscription key to have a proper encoding

  }, {
    key: "_handleSubscriptionKey",
    value: function _handleSubscriptionKey(key) {
      if (Buffer.isBuffer(key)) {
        key = toB58String(key);
      }

      var subscriber = this._subscriptions[key];

      if (!subscriber) {
        throw errcode(new Error("key ".concat(key, " does not correspond to a subscription")), 'ERR_INVALID_KEY');
      }

      var keys;

      try {
        keys = ipns.getIdKeys(fromB58String(subscriber));
      } catch (err) {
        log.error(err);
        throw err;
      }

      return keys.routingKey.toBuffer();
    }
    /**
     * Get pubsub subscriptions related to ipns.
     * @param {function(Error, Object)} callback
     * @returns {Array<Object>}
     */

  }, {
    key: "getSubscriptions",
    value: function getSubscriptions() {
      var subscriptions = Object.values(this._subscriptions).filter(Boolean);
      return subscriptions.map(function (sub) {
        return "".concat(ipns.namespace).concat(sub);
      });
    }
    /**
     * Cancel pubsub subscriptions related to ipns.
     * @param {String} name ipns path to cancel the pubsub subscription.
     * @param {function(Error, Object)} callback
     * @returns {void}
     */

  }, {
    key: "cancel",
    value: function () {
      var _cancel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(name) {
        var _this = this;

        var stringifiedTopic, bufTopic;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(typeof name !== 'string')) {
                  _context3.next = 2;
                  break;
                }

                throw errcode(new Error('invalid subscription name'), 'ERR_INVALID_SUBSCRIPTION_NAME');

              case 2:
                // Trim /ipns/ prefix from the name
                if (name.startsWith(ipns.namespace)) {
                  name = name.substring(ipns.namespaceLength);
                }

                stringifiedTopic = Object.keys(this._subscriptions).find(function (key) {
                  return _this._subscriptions[key] === name;
                }); // Not found topic

                if (stringifiedTopic) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt("return", {
                  canceled: false
                });

              case 6:
                // Unsubscribe topic
                bufTopic = Buffer.from(stringifiedTopic);

                this._pubsubDs.unsubscribe(bufTopic);

                this._subscriptions[stringifiedTopic] = undefined;
                log("unsubscribed pubsub ".concat(stringifiedTopic, ": ").concat(name));
                return _context3.abrupt("return", {
                  canceled: true
                });

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function cancel(_x4) {
        return _cancel.apply(this, arguments);
      }

      return cancel;
    }()
  }]);

  return IpnsPubsubDatastore;
}();

exports = module.exports = withIs(IpnsPubsubDatastore, {
  className: 'IpnsPubsubDatastore',
  symbolName: '@js-ipfs/ipns/IpnsPubsubDatastore'
});